import React from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';
import { defaultTheme } from '../../data/themes';
import Error from './error';
import { getErrorType } from '../../data/validation';

/*
			.ps-error {
				position: absolute;
				display: none;
				display: none;
				top: 100%;
				left: 0px;
				width: 100%;
				z-index: 100;
			}
			&:focus-within {
				.ps-error {
					display: block;
				}
			}
*/

const FormItemWrapper = styled.label`
	border: none;
	position: relative;
	display: inline-block;
	padding: 0px;
	margin: ${props => props.margin ?? props.theme.formItemMargin ?? defaultTheme.formItemMargin};
	margin-right: ${props => props.marginRight};
	width: ${props => props.width ?? props.minWidth};
	min-width: ${props => props.minWidth};
	${props => props.fixedWidth ? css`
			flex-basis: ${props.fixedWidth};
			flex-grow: 0 !important;
			flex-shring: 0 !important;
	` : css``}
`;

const InnerWrapper = styled.div`
	padding: ${props => props.padding ?? props.theme.formItemPadding ?? defaultTheme.formItemPadding};
	position: relative;
	width: 100%;

	> .ps-formItem-label {
		position: relative;

		> .rightIcons {
			position: absolute;
			right: 0px;
			top: 0px;
			display: none;
		}

	}

	&:hover {
		> .ps-formItem-label {
			> .rightIcons {
				display: block;
			}
		}
	}

	${props => props.theme.formItemLabelInside ?? defaultTheme.formItemLabelInside ? css`
			border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius};
			background: ${props => props.theme.inputBackground ?? defaultTheme.inputBackground};
			border: ${props => props.theme.inputBorder ?? defaultTheme.inputBorder};


			${props => props.hilited && css`
				background: ${props => props.theme.inputHilitedBackground || defaultTheme.inputHilitedBackground} !important;
				input {
					font-size: ${props => props.theme.inputHilitedFontSize || defaultTheme.inputHilitedFontSize} !important;
				}
			`}

			&.readOnly {
				background: ${props => props.theme.inputReadOnlyBackground ?? defaultTheme.inputReadOnlyBackground};
			}
			&.error {
				background: ${props => props.theme.inputErrorBackground ?? defaultTheme.inputErrorBackground};
				border-color: ${props => props.theme.inputErrorBorderColor ?? defaultTheme.inputErrorBorderColor};
			}
			&.warning {
				background: ${props => props.theme.inputWarningBackground ?? defaultTheme.inputWarningBackground};
				border-color: ${props => props.theme.inputWarningBorderColor ?? defaultTheme.inputWarningBorderColor};
			}
			> .ps-input {
				width: 100%;
				border: none;
				outline: none;
				background: transparent !important;
			}
			input {
				background: transparent !important;
			}
		` : css`
			border: none;
			border-radius: 0px;
			> .ps-input {
				width: 100%;

				${props => props.hilited && css`
					background: ${props => props.theme.inputHilitedBackground || defaultTheme.inputHilitedBackground} !important;
					font-size: ${props => props.theme.inputHilitedFontSize || defaultTheme.inputHilitedFontSize} !important;
					input {
						font-size: ${props => props.theme.inputHilitedFontSize || defaultTheme.inputHilitedFontSize} !important;
					}
				`}

			}
			&.error {
				> .ps-input {
					background: ${props => props.theme.inputErrorBackground ?? defaultTheme.inputErrorBackground};
					border-color: ${props => props.theme.inputErrorBorderColor ?? defaultTheme.inputErrorBorderColor};
				}
			}
			&.warning {
				> .ps-input {
					background: ${props => props.theme.inputWarningBackground ?? defaultTheme.inputWarningBackground};
					border-color: ${props => props.theme.inputWarningBorderColor ?? defaultTheme.inputWarningBorderColor};
				}
			}
		`
	}
	${props => (props.theme.formItemFocusMarker ?? defaultTheme.formItemFocusMarker) && css`
			&:focus-within {
				> .ps-formItem-focusMarker {
					display: block;
				}
			}
		`
	}

	> .ps-formItem-focusMarker {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 4px;
		background: #3B3B3B;
		opacity: 0.7;
		display: none;
		border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius} ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius} 0px 0px;
	}

	> .ps-formItem-label {
		color: ${props => props.theme.formItemLabelColor ?? defaultTheme.formItemLabelColor};
		font-size: ${props => props.theme.formItemLabelFontSize ?? defaultTheme.formItemLabelFontSize};
		font-weight: ${props => props.theme.formItemLabelFontWeight ?? defaultTheme.formItemLabelFontWeight};
		padding: ${props => props.theme.formItemLabelPadding ?? defaultTheme.formItemLabelPadding};
	}

	&.error {
		> .ps-formItem-label {
			color: ${props => props.theme.formItemErrorLabelColor ?? defaultTheme.formItemErrorLabelColor};
		}
	}
	&.warning {
		> .ps-formItem-label {
			color: ${props => props.theme.formItemWarningLabelColor ?? defaultTheme.formItemWarningLabelColor};
		}
	}

`;

export default class FormItem extends React.PureComponent {

	render() {
		return (
			<FormItemWrapper
				className={'ps-formItem' + (this.props.error ? ' error' : '') + (this.props.className ? ' ' + this.props.className : '')}
				data-name={this.props.name}
				width={this.props.width}
				fixedWidth={this.props.fixedWidth}
				minWidth={this.props.minWidth}
				margin={this.props.margin}
				marginRight={this.props.marginRight}
			>
				<InnerWrapper
					className={'ps-lookupAnchor ' + (getErrorType(this.props.error) || '') + (this.props.readOnly ? ' readOnly' : '')}
					hilited={this.props.hilited}
				>
					{
						!this.props.noFocusMarker && (
							<div className="ps-formItem-focusMarker"/>
						)
					}
					<div className="ps-formItem-label">
						{this.props.leftIcons && (
							<span className="leftIcons">
								{this.props.leftIcons}
							</span>
						)}
						{this.props.label}
						{this.props.rightIcons && (
							<span className="rightIcons">
								{this.props.rightIcons}
							</span>
						)}
					</div>
					{
						this.props.children
					}
				</InnerWrapper>
				<Error error={this.props.error}/>
			</FormItemWrapper>
		)
	}
}

FormItem.propTypes = {
	label: PropTypes.string,
	value: PropTypes.any
};
